import { forwardRef, lazy, Suspense, Ref } from 'react'
import { lazyLoadHelper } from 'routes/resources'
import LazyLoadingSkeleton from 'core/components/loaders/LazyLoadingSkeleton'
import {
  TripDetailProps,
  TripDetailRef
} from 'core/widgets/trip-detail/TripDetail'

const TripDetail = lazy(() =>
  lazyLoadHelper(import('core/widgets/trip-detail/TripDetail'))
)

const TripDetailLazy = forwardRef(
  (props: TripDetailProps, ref: Ref<TripDetailRef>) => (
    <Suspense fallback={<LazyLoadingSkeleton variant="trip-detail" />}>
      <TripDetail ref={ref} {...props} />
    </Suspense>
  )
)

export default TripDetailLazy
